export { bankCrbMonitorRoute } from './route'
